import { isNil } from 'lodash';
import { MBIconV2Name } from '@shared/components/image';
import { isSubformComponent } from '../../utils';
import { FieldOption } from './FieldOption';

export class SubformFieldOption implements FieldOption {
  constructor(
    readonly title: string,
    readonly icon: MBIconV2Name,
    readonly component: Partial<MBAPI.WorkflowTemplate_components_SubformComponent>,
  ) {}

  matchesComponent(
    component: MBAPI.WorkflowTemplate_components,
    _reservedIds: Array<string>,
  ): boolean {
    return isSubformComponent(component);
  }

  canBeAdded(components: MBAPI.WorkflowTemplate_components[]): boolean {
    return isNil(components.find(c => c.type === 'SUBFORM'));
  }
}
